// 運行実績×収支ビュー（中身/TMS・Firestore連動）。trips＋tachographs を月で絞り、客先別 実コスト収支・実車率を表示。
// 集約は ace_tms_pipeline を移植した computeOperations（6月＝確定値と一致を検証済み）。
// デモ時は同梱 sample.ops.json（6月分の形をした架空データ。scripts/make-sample-data.mjs が生成）で動く。プロトタイプの詳細タブは「別タブで開く」。
import { computeOperations } from '../data/analytics/operations.js'
import { COLLECTIONS, listDocs } from '../data/collections.js'
import { refreshLabor } from '../data/laborRates.js'
import { supabaseReady } from '../supabase.js'
import { resolveMonth, setSelectedMonth } from '../data/selectedMonth.js'
import sampleOps from './sample.ops.json'
import { allowSample, DEMO_TAG, noDataHtml } from '../data/demoData.js'

const YEN = (n) => '¥' + Math.round(Number(n) || 0).toLocaleString('ja-JP')
const KM = (n) => Math.round(Number(n) || 0).toLocaleString('ja-JP') + 'km'
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]))
const pad = (n) => String(n).padStart(2, '0')
const monthOf = (o, kd) => o.month || (o[kd] ? '2026-' + pad(o[kd][0]) : (o.date ? String(o.date).slice(0, 7) : ''))

const O = { el: null, ctx: {}, month: null, months: [], trips: [], tachos: [], online: false, fetchError: false, isSample: false, names: {}, vehRates: {}, vehClass: {}, tab: 'summary', meisaiSrc: 'all', meisaiQ: '', ddQ: '', colW: {},
  sort: { summary: { key: 'contrib', dir: 'desc' }, drivers: { key: 'contrib', dir: 'desc' }, vehicles: { key: 'uri', dir: 'desc' }, partners: { key: 'arari', dir: 'desc' }, custDrivers: { key: 'customer', dir: 'asc' }, meisai: { key: 'smargin', dir: 'asc' }, driverDays: { key: 'smargin', dir: 'asc' }, staff: { key: 'arari', dir: 'desc' } } }

function styleOnce() {
  if (document.getElementById('op-style')) return
  const s = document.createElement('style'); s.id = 'op-style'
  s.textContent = `
  .op{display:flex;flex-direction:column;gap:12px}
  .op-bar{display:flex;align-items:center;gap:12px;flex-wrap:wrap}
  .op-bar select{font-family:inherit;font-size:13px;padding:6px 10px;border:1px solid var(--e1);border-radius:8px;background:var(--card);color:var(--text)}
  .op-seg{display:inline-flex;background:var(--card);border-radius:9px;padding:3px}
  .op-seg button{border:0;background:transparent;font-family:inherit;font-size:12.5px;font-weight:700;color:var(--text);padding:6px 13px;border-radius:7px;cursor:pointer}
  .op-seg button.on{background:var(--accent-fill);color:#fff}
  .op-open{margin-left:auto;font-size:12px;color:var(--text);text-decoration:none;background:var(--card);border:1px solid var(--e1);border-radius:8px;padding:6px 12px}
  .op-demo{font-size:11px;color:var(--signal);background:transparent;border:1px solid var(--accent);border-radius:999px;padding:3px 10px}
  .op-kpis{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:10px}
  .op-kpi{background:var(--card);border:1px solid var(--e1);border-radius:10px;padding:11px 13px}
  .op-kpi .k{font-size:10.5px;color:var(--muted)}.op-kpi .v{font-size:19px;font-weight:700;font-variant-numeric:tabular-nums;margin-top:2px}
  .op-kpi.pos .v{color:var(--pos)}.op-kpi.neg .v{color:var(--neg)}.op-kpi.acc .v{color:var(--text)}
  .op-kpi .s{font-size:10px;color:var(--muted);margin-top:1px}
  .op-tblwrap{border:1px solid var(--e1);border-radius:12px;overflow:hidden;background:var(--card)}
  .op-tblwrap .cap{padding:9px 13px;font-size:12px;font-weight:700;color:var(--muted);background:var(--head);border-bottom:1px solid var(--e1)}
  .op-scroll{max-height:52vh;overflow:auto}
  table.op-tbl{width:100%;border-collapse:collapse;font-size:12px}
  .op-tbl th,.op-tbl td{padding:6px 11px;border-bottom:1px solid var(--e3);text-align:left;white-space:nowrap}
  .op-tbl th{position:sticky;top:0;background:var(--head);color:var(--text);font-size:10.5px;z-index:1}
  .op-tbl td.n,.op-tbl th.n{text-align:right;font-variant-numeric:tabular-nums}
  .op-tbl td.pos{color:var(--pos);font-weight:700}.op-tbl td.neg{color:var(--neg);font-weight:700}
  .op-tbl th.sortable{cursor:pointer;user-select:none}
  .op-tbl th.sortable:hover{background:var(--e2);color:var(--signal)}
  .op-tbl th .arw{color:var(--text);font-size:9px;margin-left:2px}
  .op-note{font-size:11px;color:var(--muted);line-height:1.6}
  .ms-bar{display:inline-flex;gap:8px;align-items:center;margin-top:7px;vertical-align:middle}
  .ms-q{font-family:inherit;font-size:12px;padding:5px 9px;border:1px solid var(--e1);border-radius:7px;min-width:220px}
  .ms-b{font-size:9.5px;font-weight:700;border-radius:4px;padding:1px 6px}
  .ms-est{font-size:9px;color:var(--text);margin-left:4px}
  .op-tbl th{box-sizing:border-box}
  .op-rz{position:absolute;top:0;right:0;width:7px;height:100%;cursor:col-resize;user-select:none;z-index:2}
  .op-rz:hover{background:var(--e2)}
  `
  document.head.appendChild(s)
}

export async function renderOperations(el, ctx = {}) {
  styleOnce()
  O.el = el
  O.ctx = ctx
  O.online = !ctx.demo && supabaseReady
  O.fetchError = false
  el.innerHTML = '<div class="ct-state is-loading"><b class="ct-state__t">集計しています…</b><span>選択月の運行実績を集計しています</span></div>'
  // 乗務員別の歩合率・試算用率を描画のたびに取り直す（2026-09-03 給与F1）。
  // 乗務員画面で率を直した直後でも、収支と給与が同じ率を見る＝両画面の人件費が食い違わない。
  // 失敗しても直前の設定を保つ（laborRates.js）ので、数字が勝手にフォールバックへ化けることはない。
  try { await refreshLabor(true) } catch { /* 直前の設定のまま続行 */ }
  let trips = sampleOps.trips, tachos = sampleOps.tachographs
  if (O.online) {
    try {
      const [tr, ta, dr, vh] = await Promise.all([listDocs(COLLECTIONS.trips), listDocs(COLLECTIONS.tachographs), listDocs(COLLECTIONS.drivers), listDocs(COLLECTIONS.vehicles)])
      if (tr && tr.length) {
        trips = tr; tachos = ta || []; O.names = {}; O.vehRates = {}; O.vehClass = {}
        for (const d of (dr || [])) { const k = String(d.code || d.id || '').replace(/^0+(?=\d)/, ''); if (k) O.names[k] = d.name || '' }
        // 車両台帳マスタ → 車番/乗務員代替キーごとの日額・車種（実データ化。id は車両台帳ビューが engine cn で保存）
        for (const m of (vh || [])) { const id = m.id; if (id == null) continue; if (m.dailyCost != null && m.dailyCost !== '') O.vehRates[id] = Number(m.dailyCost); if (m.klass) O.vehClass[id] = m.klass }
      } else if (!allowSample(O.online)) {
        // 実データ0件。サンプルへ落ちてよいかは共通判定 allowSample（設定 settings/display）に委ねる
        trips = []; tachos = []
      }
    } catch { O.online = false; O.fetchError = true }
  }
  // サインイン済みの実fetch失敗はサンプルへフォールバックせず is-error を主表示にする
  // （サンプル描画は明示的なデモ状況＝online初期値false のときだけ。2026-08-27 負債解消）
  if (O.fetchError) { O.trips = []; O.tachos = []; O.isSample = false; paintFetchError(); return }
  O.isSample = trips === sampleOps.trips
  // 実データ0件＋デモ表示OFF＝正直に空を出す（架空の実績を本物の顔で並べない。2026-08-27 案C）
  if (!O.isSample && !trips.length) { O.trips = []; O.tachos = []; paintNoData(); return }
  O.trips = trips; O.tachos = tachos
  const ms = new Set(trips.map((t) => monthOf(t, 'dm')).filter(Boolean))
  const picked = resolveMonth([...ms])
  O.months = picked.months
  O.month = picked.month
  paint(ctx)
}

const sign = (n) => (n >= 0 ? 'pos' : 'neg')

// 実fetch失敗（デモ意図とは別）の主表示。サンプルデータは描画しない
function paintFetchError() {
  O.el.innerHTML = '<section class="op"><div class="ct-state is-error"><b class="ct-state__t">データを読み込めませんでした</b><span>保存済みの実データを取得できませんでした。誤認を避けるためサンプルは表示していません。接続を確認して再試行してください</span><button type="button" class="btn" id="op-retry">再試行</button></div></section>'
  const retry = O.el.querySelector('#op-retry'); if (retry) retry.addEventListener('click', () => { renderOperations(O.el, O.ctx) })
}

// 実データ0件＋デモデータ表示OFF（既定）の主表示。サンプルは描かない
function paintNoData() {
  O.el.innerHTML = `<section class="op">${noDataHtml('運行実績×収支')}</section>`
}

// デジタコがある月（＝6月）からフリート実績レートを算出。デジタコ未取込の月の推定に使う。
function fleetRef() {
  let km = 0, load = 0, fuel = 0
  for (const t of O.tachos) {
    km += Number(t.runKm != null ? t.runKm : t.km) || 0
    load += Number(t.loadedKm != null ? t.loadedKm : t.loaded) || 0
    fuel += Number(t.fuelLiter != null ? t.fuelLiter : t.fuel) || 0
  }
  if (!km) return null
  const degMonths = new Set(O.tachos.map((t) => monthOf(t, 'sd')).filter(Boolean))
  const ownFare = O.trips.filter((t) => t.kind === 'own' && degMonths.has(monthOf(t, 'dm'))).reduce((a, t) => a + (Number(t.fare) || 0), 0) || 1
  return { rate: fuel * 150 / km, kmpy: km / ownFare, jissharitsu: load / km, kmL: km / fuel }
}

// 並び替え：数値は数値比較、テキストはロケール比較。dir=asc/desc。
function sortRows(arr, key, dir) {
  const mul = dir === 'asc' ? 1 : -1
  return [...arr].sort((a, b) => {
    const av = a[key], bv = b[key]
    if (typeof av === 'number' && typeof bv === 'number') return (av - bv) * mul
    return String(av == null ? '' : av).localeCompare(String(bv == null ? '' : bv), 'ja') * mul
  })
}
// 列見出しクリックでソートできる表を生成（cols: {key,label,num?,cell}）
function sortableTable(tab, cap, cols, data) {
  const st = O.sort[tab] || {}
  const rows = (st.key ? sortRows(data, st.key, st.dir) : data)
    .map((r) => `<tr>${cols.map((c) => c.cell(r)).join('')}</tr>`).join('')
  const ths = cols.map((c) => {
    const on = st.key === c.key
    const arw = on ? `<span class="arw">${st.dir === 'asc' ? '▲' : '▼'}</span>` : ''
    return `<th class="sortable${c.num ? ' n' : ''}" data-key="${c.key}" data-type="${c.num ? 'num' : 'text'}">${c.label}${arw}</th>`
  }).join('')
  return `<div class="cap">${cap}<span style="font-weight:400;color:var(--text)"> · 見出しクリックで並び替え</span></div>
    <div class="op-scroll"><table class="op-tbl">
      <thead><tr>${ths}</tr></thead>
      <tbody>${rows}</tbody></table></div>`
}

function tableSummary(custs) {
  return sortableTable('summary', `客先別 収支（${custs.length}社）`, [
    { key: 'name', label: '客先', cell: (c) => `<td>${esc(c.name)}</td>` },
    { key: 'uri', label: '総売上', num: 1, cell: (c) => `<td class="n">${YEN(c.uri)}</td>` },
    { key: 'ji', label: '自社便', num: 1, cell: (c) => `<td class="n">${YEN(c.ji)}</td>` },
    { key: 'km', label: '実走行', num: 1, cell: (c) => `<td class="n">${KM(c.km)}</td>` },
    { key: 'fuel', label: '実燃料', num: 1, cell: (c) => `<td class="n">${YEN(c.fuel)}</td>` },
    { key: 'yo_arari', label: '傭車取り分', num: 1, cell: (c) => `<td class="n">${YEN(c.yo_arari)}</td>` },
    { key: 'contrib', label: '粗利益', num: 1, cell: (c) => `<td class="n ${sign(c.contrib)}">${YEN(c.contrib)}</td>` },
  ], custs)
}
function tableDrivers(drivers) {
  return sortableTable('drivers', `乗務員別 収支（${drivers.length}名）`, [
    { key: 'name', label: '乗務員', cell: (d) => `<td>${esc(d.name)}</td>` },
    { key: 'n', label: '運行', num: 1, cell: (d) => `<td class="n">${d.n}</td>` },
    { key: 'days', label: '稼働日', num: 1, cell: (d) => `<td class="n">${d.days}</td>` },
    { key: 'ji', label: '自社便売上', num: 1, cell: (d) => `<td class="n">${YEN(d.ji)}</td>` },
    { key: 'km', label: '実走行', num: 1, cell: (d) => `<td class="n">${KM(d.km)}</td>` },
    { key: 'jinken', label: '人件費', num: 1, cell: (d) => `<td class="n">${YEN(d.jinken)}</td>` },
    { key: 'carCost', label: '車両経費', num: 1, cell: (d) => `<td class="n">${YEN(d.carCost)}</td>` },
    { key: 'fuel', label: '実燃料', num: 1, cell: (d) => `<td class="n">${YEN(d.fuel)}</td>` },
    { key: 'contrib', label: '粗利益', num: 1, cell: (d) => `<td class="n ${sign(d.contrib)}">${YEN(d.contrib)}</td>` },
    { key: 'shushi', label: '収支', num: 1, cell: (d) => `<td class="n ${sign(d.shushi)}">${YEN(d.shushi)}</td>` },
  ], drivers)
}
function tableVehicles(vehicles) {
  return sortableTable('vehicles', `車両別 採算（${vehicles.length}台・突合できた運行分）`, [
    { key: 'name', label: '車番', cell: (v) => `<td>${esc(v.name)}</td>` },
    { key: 'days', label: '稼働', num: 1, cell: (v) => `<td class="n">${v.days}</td>` },
    { key: 'km', label: '走行', num: 1, cell: (v) => `<td class="n">${KM(v.km)}</td>` },
    { key: 'jissharitsu', label: '実車率', num: 1, cell: (v) => `<td class="n">${(v.jissharitsu * 100).toFixed(0)}%</td>` },
    { key: 'kmL', label: '実燃費', num: 1, cell: (v) => `<td class="n">${v.kmL}km/L</td>` },
    { key: 'uri', label: '売上', num: 1, cell: (v) => `<td class="n">${YEN(v.uri)}</td>` },
    { key: 'contrib', label: '粗利益', num: 1, cell: (v) => `<td class="n ${sign(v.contrib)}">${YEN(v.contrib)}</td>` },
  ], vehicles)
}

function tablePartners(partners) {
  return sortableTable('partners', `利用運送 収支（${partners.length}社・傭車のみ）`, [
    { key: 'name', label: '協力会社', cell: (p) => `<td>${esc(p.name)}</td>` },
    { key: 'n', label: '運行', num: 1, cell: (p) => `<td class="n">${p.n}</td>` },
    { key: 'uri', label: '請求(運賃)', num: 1, cell: (p) => `<td class="n">${YEN(p.uri)}</td>` },
    { key: 'pay', label: '支払(傭車)', num: 1, cell: (p) => `<td class="n">${YEN(p.pay)}</td>` },
    { key: 'arari', label: '粗利', num: 1, cell: (p) => `<td class="n ${sign(p.arari)}">${YEN(p.arari)}</td>` },
    { key: 'rate', label: '粗利率', num: 1, cell: (p) => `<td class="n">${p.rate}%</td>` },
  ], partners)
}

function tableCustDrivers(rows) {
  return sortableTable('custDrivers', `得意先×乗務員 収支（${rows.length}件・自社便）`, [
    { key: 'customer', label: '得意先', cell: (r) => `<td>${esc(r.customer)}</td>` },
    { key: 'driver', label: '乗務員', cell: (r) => `<td>${esc(r.driver)}</td>` },
    { key: 'n', label: '運行', num: 1, cell: (r) => `<td class="n">${r.n}</td>` },
    { key: 'uri', label: '自社便売上', num: 1, cell: (r) => `<td class="n">${YEN(r.uri)}</td>` },
    { key: 'jinken', label: '人件費', num: 1, cell: (r) => `<td class="n">${YEN(r.jinken)}</td>` },
    { key: 'fuel', label: '実燃料', num: 1, cell: (r) => `<td class="n">${YEN(r.fuel)}</td>` },
    { key: 'carCost', label: '車両経費', num: 1, cell: (r) => `<td class="n">${YEN(r.carCost)}</td>` },
    { key: 'shushi', label: '収支', num: 1, cell: (r) => `<td class="n ${sign(r.shushi)}">${YEN(r.shushi)}</td>` },
  ], rows)
}

// 配車担当別：trips.staff で自社便＋傭車を集計。車両経費は自社便売上比でフリート配賦。
function tableStaff(rows) {
  return sortableTable('staff', `配車担当別 収支（${rows.length}名・自社便＋傭車）`, [
    { key: 'staff', label: '配車担当', cell: (r) => `<td>${esc(r.staff)}</td>` },
    { key: 'n', label: '運行', num: 1, cell: (r) => `<td class="n">${r.n}</td>` },
    { key: 'uri', label: '自社便売上', num: 1, cell: (r) => `<td class="n">${YEN(r.uri)}</td>` },
    { key: 'yoArari', label: '傭車粗利', num: 1, cell: (r) => `<td class="n">${YEN(r.yoArari)}</td>` },
    { key: 'jinken', label: '人件費', num: 1, cell: (r) => `<td class="n">${YEN(r.jinken)}</td>` },
    { key: 'fuel', label: '実燃料', num: 1, cell: (r) => `<td class="n">${YEN(r.fuel)}</td>` },
    { key: 'arari', label: '粗利益', num: 1, cell: (r) => `<td class="n ${sign(r.arari)}">${YEN(r.arari)}</td>` },
    { key: 'carCost', label: '車両経費', num: 1, cell: (r) => `<td class="n">${YEN(r.carCost)}</td>` },
    { key: 'shushi', label: '収支', num: 1, cell: (r) => `<td class="n ${sign(r.shushi)}">${YEN(r.shushi)}</td>` },
  ], rows)
}

// 便明細：1便ごとの発→着・運賃(単価)・原価・粗利・粗利率。区分セグ＋テキスト絞り込み＋列ソート（既定＝粗利率 昇順＝単価が弱い便が上）。
function tableMeisai(meisai) {
  const src = O.meisaiSrc, q = (O.meisaiQ || '').trim().toLowerCase()
  let data = meisai
  if (src !== 'all') data = data.filter((r) => r.kind === src)
  if (q) data = data.filter((r) => (r.customer + ' ' + r.who + ' ' + r.from + ' ' + r.to + ' ' + r.vType).toLowerCase().includes(q))
  const total = data.length
  const CAP = 1500
  const st = O.sort.meisai || { key: 'margin', dir: 'asc' }
  const sorted = st.key ? sortRows(data, st.key, st.dir) : data
  const shown = sorted.slice(0, CAP)
  const kb = (k) => k === 'own'
    ? '<span class="ms-b" style="color:var(--text);background:transparent">自社便</span>'
    : '<span class="ms-b" style="color:var(--signal);background:transparent">傭車</span>'
  const cols = [
    { key: 'date', label: '日付', cell: (r) => `<td>${esc(r.date)}</td>` },
    { key: 'kind', label: '区分', cell: (r) => `<td>${kb(r.kind)}${r.kind === 'own' && !r.matched ? '<span class="ms-est">推定</span>' : ''}</td>` },
    { key: 'customer', label: '得意先', cell: (r) => `<td>${esc(r.customer)}</td>` },
    { key: 'who', label: '乗務員/協力', cell: (r) => `<td>${esc(r.who)}</td>` },
    { key: 'from', label: '発', cell: (r) => `<td>${esc(r.from)}</td>` },
    { key: 'to', label: '着', cell: (r) => `<td>${esc(r.to)}</td>` },
    { key: 'vType', label: '車種', cell: (r) => `<td>${esc(r.vType)}</td>` },
    { key: 'fare', label: '運賃(単価)', num: 1, cell: (r) => `<td class="n">${YEN(r.fare)}</td>` },
    { key: 'jinken', label: '人件費', num: 1, cell: (r) => `<td class="n">${r.kind === 'own' ? YEN(r.jinken) : '—'}</td>` },
    { key: 'fuel', label: '燃料', num: 1, cell: (r) => `<td class="n">${r.kind === 'own' ? YEN(r.fuel) : '—'}</td>` },
    { key: 'charterCost', label: '傭車料', num: 1, cell: (r) => `<td class="n">${r.kind === 'charter' ? YEN(r.charterCost) : '—'}</td>` },
    { key: 'arari', label: '粗利益', num: 1, cell: (r) => `<td class="n ${sign(r.arari)}">${YEN(r.arari)}</td>` },
    { key: 'carCost', label: '車両経費', num: 1, cell: (r) => `<td class="n">${r.kind === 'own' ? YEN(r.carCost) : '—'}</td>` },
    { key: 'shushi', label: '収支', num: 1, cell: (r) => `<td class="n ${sign(r.shushi)}">${YEN(r.shushi)}</td>` },
    { key: 'smargin', label: '収支率', num: 1, cell: (r) => `<td class="n ${r.smargin < 0 ? 'neg' : ''}">${r.smargin}%</td>` },
  ]
  const ths = cols.map((c) => {
    const on = st.key === c.key; const arw = on ? `<span class="arw">${st.dir === 'asc' ? '▲' : '▼'}</span>` : ''
    return `<th class="sortable${c.num ? ' n' : ''}" data-key="${c.key}" data-type="${c.num ? 'num' : 'text'}">${c.label}${arw}</th>`
  }).join('')
  const rowsHtml = shown.length
    ? shown.map((r) => `<tr>${cols.map((c) => c.cell(r)).join('')}</tr>`).join('')
    : `<tr><td colspan="${cols.length}" style="border:0">${(src === 'all' && !q)
        ? '<div class="ct-state is-empty"><b class="ct-state__t">この月の便明細はありません</b><span>月を切り替えるか、運行実績を取り込んでください</span></div>'
        : '<div class="ct-state is-nomatch"><b class="ct-state__t">この条件に一致する便はありません</b><span>区分・検索条件をクリアしてください</span></div>'}</td></tr>`
  const SEG = [['all', '全部'], ['own', '自社便'], ['charter', '傭車']]
  const seg = SEG.map(([id, lab]) => `<button data-ms="${id}" class="${src === id ? 'on' : ''}">${lab}</button>`).join('')
  return `<div class="cap">便明細（${total}件・収支率の低い順＝単価が弱い便が上／見出しクリックで並び替え）${total > CAP ? `<span style="font-weight:400;color:var(--neg)"> ※先頭${CAP}件を表示</span>` : ''}
      <div class="ms-bar"><div class="op-seg">${seg}</div><input id="ms-q" class="ms-q" placeholder="得意先・乗務員・発着で絞り込み" value="${esc(O.meisaiQ)}"></div></div>
    <div class="op-scroll"><table class="op-tbl">
      <thead><tr>${ths}</tr></thead><tbody>${rowsHtml}</tbody></table></div>`
}

// 日別乗務員：乗務員×運行日で 売上・原価・粗利＋その日1台日の車両経費(大型¥20,000/中型¥11,000)・収支・収支率。
function tableDriverDays(rows) {
  const q = (O.ddQ || '').trim().toLowerCase()
  let data = q ? rows.filter((r) => (r.date + ' ' + r.driver + ' ' + r.cars).toLowerCase().includes(q)) : rows
  const total = data.length
  const CAP = 1500
  const st = O.sort.driverDays || { key: 'smargin', dir: 'asc' }
  const sorted = st.key ? sortRows(data, st.key, st.dir) : data
  const shown = sorted.slice(0, CAP)
  const cols = [
    { key: 'date', label: '日付', cell: (r) => `<td>${esc(r.date)}</td>` },
    { key: 'driver', label: '乗務員', cell: (r) => `<td>${esc(r.driver)}</td>` },
    { key: 'cls', label: '車種', cell: (r) => `<td>${esc(r.cls)}</td>` },
    { key: 'km', label: '走行距離', num: 1, cell: (r) => `<td class="n">${KM(r.km)}</td>` },
    { key: 'uri', label: '売上', num: 1, cell: (r) => `<td class="n">${YEN(r.uri)}</td>` },
    { key: 'jinken', label: '人件費', num: 1, cell: (r) => `<td class="n">${YEN(r.jinken)}</td>` },
    { key: 'carCost', label: '車両経費', num: 1, cell: (r) => `<td class="n">${YEN(r.carCost)}</td>` },
    { key: 'fuel', label: '燃料', num: 1, cell: (r) => `<td class="n">${YEN(r.fuel)}</td>` },
    { key: 'shushi', label: '収支', num: 1, cell: (r) => `<td class="n ${sign(r.shushi)}">${YEN(r.shushi)}</td>` },
    { key: 'smargin', label: '収支率', num: 1, cell: (r) => `<td class="n ${r.smargin < 0 ? 'neg' : ''}">${r.smargin}%</td>` },
  ]
  const ths = cols.map((c) => {
    const on = st.key === c.key; const arw = on ? `<span class="arw">${st.dir === 'asc' ? '▲' : '▼'}</span>` : ''
    return `<th class="sortable${c.num ? ' n' : ''}" data-key="${c.key}" data-type="${c.num ? 'num' : 'text'}">${c.label}${arw}</th>`
  }).join('')
  const rowsHtml = shown.length
    ? shown.map((r) => `<tr>${cols.map((c) => c.cell(r)).join('')}</tr>`).join('')
    : `<tr><td colspan="${cols.length}" style="border:0">${!q
        ? '<div class="ct-state is-empty"><b class="ct-state__t">この月の日別乗務員データはありません</b><span>月を切り替えるか、運行実績を取り込んでください</span></div>'
        : '<div class="ct-state is-nomatch"><b class="ct-state__t">この条件に一致する日はありません</b><span>検索条件をクリアしてください</span></div>'}</td></tr>`
  return `<div class="cap">日別乗務員 収支（${total}件・収支率の低い順／見出しクリックで並び替え）${total > CAP ? `<span style="font-weight:400;color:var(--neg)"> ※先頭${CAP}件を表示</span>` : ''}
      <div class="ms-bar"><input id="dd-q" class="ms-q" placeholder="乗務員・日付で絞り込み" value="${esc(O.ddQ)}"></div></div>
    <div class="op-scroll"><table class="op-tbl">
      <thead><tr>${ths}</tr></thead><tbody>${rowsHtml}</tbody></table></div>`
}

// 列幅リサイズ：各thの右端にハンドルを付けドラッグで幅変更。幅は O.colW['tab:key'] に保持し再描画後も復元。
function applyAndResize(root) {
  root.querySelectorAll('table.op-tbl thead th').forEach((th) => {
    const key = th.dataset.key, wk = O.tab + ':' + key
    if (key && O.colW[wk]) { th.style.width = O.colW[wk] + 'px'; th.style.minWidth = O.colW[wk] + 'px' }
    if (th.querySelector('.op-rz')) return
    th.style.position = 'relative'
    const rz = document.createElement('span'); rz.className = 'op-rz'; th.appendChild(rz)
    rz.addEventListener('click', (e) => e.stopPropagation())
    rz.addEventListener('mousedown', (e) => {
      e.preventDefault(); e.stopPropagation()
      const sx = e.clientX, sw = th.offsetWidth
      const onMove = (ev) => { const w = Math.max(40, sw + (ev.clientX - sx)); th.style.width = w + 'px'; th.style.minWidth = w + 'px'; if (key) O.colW[wk] = w }
      const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); document.body.style.userSelect = '' }
      document.body.style.userSelect = 'none'
      document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp)
    })
  })
}

function paint(ctx) {
  const el = O.el
  if (!O.trips.length) {
    el.innerHTML = `
      <section class="op">
        <div class="op-bar">
          ${O.isSample ? `<span class="op-demo">${DEMO_TAG}</span>` : ''}
        </div>
        <div class="op-tblwrap"><div class="ct-state is-empty"><b class="ct-state__t">運行実績がまだありません</b><span>運行実績を取り込むと、客先別・乗務員別などの収支表がここに表示されます</span></div></div>
      </section>`
    return
  }
  const trips = O.trips.filter((t) => monthOf(t, 'dm') === O.month)
  const tachos = O.tachos.filter((t) => monthOf(t, 'sd') === O.month)
  const ref = tachos.length ? {} : (fleetRef() || {})
  const { summary: s, custs, drivers, vehicles, partners, custDrivers, meisai, driverDays, staffAgg } = computeOperations(trips, tachos, { ...ref, names: O.names, vehRates: O.vehRates, vehClass: O.vehClass })
  const opts = O.months.map((m) => `<option value="${m}" ${m === O.month ? 'selected' : ''}>${m.replace('-', '年')}月</option>`).join('')
  const TABS = [['summary', '客先別'], ['drivers', '乗務員別'], ['vehicles', '車両別'], ['partners', '利用運送'], ['custDrivers', '得意先×乗務員'], ['staff', '配車担当別'], ['meisai', '便明細'], ['driverDays', '日別乗務員']]
  const tabbar = TABS.map(([id, lab]) => `<button data-tab="${id}" class="${O.tab === id ? 'on' : ''}">${lab}</button>`).join('')
  const body = O.tab === 'drivers' ? tableDrivers(drivers) : (O.tab === 'vehicles' ? tableVehicles(vehicles) : (O.tab === 'partners' ? tablePartners(partners) : (O.tab === 'custDrivers' ? tableCustDrivers(custDrivers) : (O.tab === 'staff' ? tableStaff(staffAgg) : (O.tab === 'meisai' ? tableMeisai(meisai) : (O.tab === 'driverDays' ? tableDriverDays(driverDays) : tableSummary(custs)))))))
  el.innerHTML = `
    <section class="op">
      <div class="op-bar">
        <select id="op-month">${opts}</select>
        <div class="op-seg">${tabbar}</div>
        ${O.isSample ? `<span class="op-demo">${DEMO_TAG}</span>` : ''}
        ${s.estimated ? '<span class="op-demo" style="background:transparent;color:var(--signal);border-color:var(--accent)">推定：この月はデジタコ未取込。6月フリート実績で走行km・燃料・粗利を推定</span>' : ''}
        <button type="button" class="op-open" data-prototype="operations">詳細プロトタイプ ↗</button>
      </div>
      <div class="op-kpis">
        <div class="op-kpi acc"><div class="k">自社便売上</div><div class="v">${YEN(s.ji_uri)}</div><div class="s">運行 ${s.self_runs}件</div></div>
        <div class="op-kpi"><div class="k">利用運送 粗利</div><div class="v">${YEN(s.yo_arari)}</div><div class="s">傭車 ${s.you_runs}件</div></div>
        <div class="op-kpi ${sign(s.contrib)}"><div class="k">粗利益</div><div class="v">${YEN(s.contrib)}</div><div class="s">車両固定費 前</div></div>
        <div class="op-kpi ${sign(s.zensha)}"><div class="k">全社収支（車両経費後）</div><div class="v">${YEN(s.zensha)}</div><div class="s">車両経費 ${YEN(s.sharyo)}</div></div>
        <div class="op-kpi"><div class="k">実車率</div><div class="v">${(s.jissharitsu * 100).toFixed(1)}%</div><div class="s">${s.estimated ? '推定(6月ベース)' : '距離加重'}</div></div>
        <div class="op-kpi"><div class="k">稼働台数</div><div class="v">${s.estimated ? '—' : s.unit_plates}</div><div class="s">デジタコ</div></div>
        <div class="op-kpi"><div class="k">総走行</div><div class="v">${Number(s.km).toLocaleString('ja-JP')}<span style="font-size:12px">km</span></div><div class="s">${s.estimated ? '自社便・推定' : '自社便'}</div></div>
        <div class="op-kpi"><div class="k">実燃費</div><div class="v">${s.kmL}<span style="font-size:12px">km/L</span></div><div class="s">${s.estimated ? '推定(6月ベース)' : '給油実測'}</div></div>
        <div class="op-kpi"><div class="k">突合率</div><div class="v">${s.estimated ? '—' : (s.match_rate * 100).toFixed(0) + '%'}</div><div class="s">${s.estimated ? '推定月は突合なし' : '乗務員CD×期間'}</div></div>
        <div class="op-kpi ${s.akaji ? 'neg' : ''}"><div class="k">赤字乗務員</div><div class="v">${s.akaji}<span style="font-size:12px"> /${s.drivers}</span></div><div class="s">粗利益＜0</div></div>
      </div>
      <div class="op-tblwrap">${body}</div>
      <div class="op-note">
        人件費率＝乗務員ごとの歩合率×運賃（適用開始日つき・積日基準。個別設定が無い乗務員・固定給は「試算用」率＝初期値35%。乗務員画面で設定）／ 燃料単価＝当月デジタコ給油実測（約¥${s.rate}/km）／ 車両経費＝車両ごとに積→卸の営業日(土日祝除外)×日額（大型¥20,000/中型¥11,000）＝当月${YEN(s.sharyo)}。乗務員別は各車に乗った営業日数で配賦（合計＝車両経費）。得意先×乗務員は各乗務員の車両経費を得意先の売上比で按分し収支まで表示（乗務員別の車両経費と合計一致）。収支＝粗利益−車両経費（自社便のみ・利用運送粗利は別掲）。<b>便明細</b>＝1便ごとの運賃(単価)・人件費・燃料・粗利益＋<b>車両経費・収支（粗利益−車両経費）・収支率</b>（傭車は運賃−傭車料＝収支）。便別車両経費＝各車の営業日ごとの日額（大型¥20,000/中型¥11,000）を「その日・その車を使った便」で等分するため<b>合計は乗務員別／得意先×乗務員の車両経費と一致</b>（1便で1日を占有すればその便が日額全額、同日に同一車で複数便なら按分）。<b>日別乗務員</b>＝乗務員×運行日で集計、車両経費はその日「1台日」（大型¥20,000/中型¥11,000）。※日別は1日1台日で数えるため、月次(§17＝積→卸の実営業日)や便明細とは車両経費の日数の数え方が異なり合計は一致しません。
        自社便は乗務員コード×運行期間でデジタコと突合し、走行kmを運賃按分。未突合はフリート平均km/¥で補完（突合率${(s.match_rate * 100).toFixed(0)}%）。車両別は突合できた運行分（＝車番が確定した分）。<b>各表は列見出しクリックで並び替え（再クリックで昇順↔降順）。</b>
        ${s.estimated ? '<br><b style="color:var(--signal)">※この月はデジタコ未取込のため、走行km・燃料・実車率・粗利は6月フリート実績（実車率・km/¥・燃費）からの推定値です。実デジタコを取り込むと自動で実測に切り替わります。</b>' : ''}
      </div>
    </section>`
  el.querySelector('#op-month').addEventListener('change', (e) => { O.month = setSelectedMonth(e.target.value) || e.target.value; paint(ctx) })
  el.querySelectorAll('[data-tab]').forEach((b) => b.addEventListener('click', () => { O.tab = b.dataset.tab; paint(ctx) }))
  el.querySelectorAll('th.sortable').forEach((th) => th.addEventListener('click', () => {
    const key = th.dataset.key, cur = O.sort[O.tab]
    if (cur && cur.key === key) cur.dir = cur.dir === 'asc' ? 'desc' : 'asc'
    else O.sort[O.tab] = { key, dir: th.dataset.type === 'text' ? 'asc' : 'desc' }
    paint(ctx)
  }))
  el.querySelectorAll('[data-ms]').forEach((b) => b.addEventListener('click', () => { O.meisaiSrc = b.dataset.ms; paint(ctx) }))
  const msq = el.querySelector('#ms-q')
  if (msq) msq.addEventListener('input', (e) => { O.meisaiQ = e.target.value; const p = e.target.selectionStart; paint(ctx); const n = O.el.querySelector('#ms-q'); if (n) { n.focus(); try { n.setSelectionRange(p, p) } catch (_) {} } })
  const ddq = el.querySelector('#dd-q')
  if (ddq) ddq.addEventListener('input', (e) => { O.ddQ = e.target.value; const p = e.target.selectionStart; paint(ctx); const n = O.el.querySelector('#dd-q'); if (n) { n.focus(); try { n.setSelectionRange(p, p) } catch (_) {} } })
  applyAndResize(el)
}
